import { supabase } from './supabase';
import { Capacitor } from '@capacitor/core';

interface SignUpData {
  email: string;
  password: string;
  fullName: string;
}

export const signUp = async ({ email, password, fullName }: SignUpData) => {
  // First attempt the signup
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName
      }
    }
  });
  
  if (error) throw error;

  // If signup successful, create profile
  if (data.user) {
    const username = email.split('@')[0];
    const { error: profileError } = await supabase
      .from('profiles')
      .insert([
        { 
          id: data.user.id,
          username,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        }
      ]);

    if (profileError) {
      console.error('Error creating profile:', profileError);
      // We don't throw here since the auth was successful
      // The profile can be created later if needed
    }
  }

  return data;
};

export const signIn = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  
  if (error) throw error;
  return data;
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};

export const resetPassword = async (email: string) => {
  // Get platform-specific redirect URL
  const redirectUrl = Capacitor.isNativePlatform()
    ? 'com.halalscanner.app://reset-password'  // Deep link URL for mobile apps
    : `${window.location.origin}/reset-password`;
  
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: redirectUrl,
  });
  
  if (error) throw error;
};

export const updatePassword = async (newPassword: string) => {
  const { error } = await supabase.auth.updateUser({
    password: newPassword
  });

  if (error) throw error;
};